export const primaryColor = 'rgb(29, 53, 87)'
export const secondaryColor = 'rgb(255, 165, 0)'